import React from "react";
import Footer from "../components/footer/Footer";

const privacySections = [
  {
    title: "Informasi yang Kami Kumpulkan",
    content: "Kami dapat mengumpulkan informasi seperti:",
    items: [
      "Nama lengkap",
      "Nomor telepon",
      "Alamat email",
      "Informasi akun",
      "Informasi transaksi",
      "Aktivitas penggunaan",
    ],
  },
  {
    title: "Penggunaan Informasi",
    content: "Informasi yang kami kumpulkan digunakan untuk:",
    items: [
      "Menyediakan dan mengelola layanan.",
      "Memverifikasi identitas pengguna.",
      "Memproses transaksi dan pengajuan.",
      "Meningkatkan kualitas dan keamanan sistem.",
      "Memenuhi kewajiban hukum yang berlaku.",
    ],
  },
  {
    title: "Keamanan Data",
    content:
      "Kami menerapkan langkah-langkah keamanan yang wajar untuk melindungi data pribadi Anda dari akses, penggunaan, atau pengungkapan yang tidak sah.",
  },
  {
    title: "Pembagian Informasi",
    content:
      "Kami tidak menjual data pribadi pengguna. Informasi hanya dapat dibagikan kepada mitra layanan atau pihak yang berwenang apabila diperlukan untuk penyediaan layanan atau sesuai ketentuan hukum.",
  },
  {
    title: "Hak Pengguna",
    content:
      "Anda berhak untuk mengakses, memperbarui, atau meminta penghapusan data pribadi sesuai dengan ketentuan peraturan perundang-undangan yang berlaku.",
  },
  {
    title: "Perubahan Kebijakan",
    content:
      "Kami dapat memperbarui Kebijakan Privasi ini sewaktu-waktu. Berlaku sejak tanggal pembaruan.",
  },
];

const PrivacyPolicyPage = () => {
  return (
    <>
      <main>
        <section className="relative h-72 overflow-hidden bg-[#3f6fe5] [--hero-grid:115px] md:h-80 lg:h-96">
          <div
            className="pointer-events-none absolute inset-0 opacity-30"
            style={{
              backgroundImage:
                "linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed)",
              backgroundRepeat: "no-repeat",
              backgroundSize:
                "var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid)",
              backgroundPosition:
                "calc(var(--hero-grid) * 3) 0, calc(var(--hero-grid) * 12) 0, calc(var(--hero-grid) * 13.6) var(--hero-grid), calc(var(--hero-grid) * 4) calc(var(--hero-grid) * 3), calc(var(--hero-grid) * 8) calc(var(--hero-grid) * 3)",
            }}
          ></div>
          <div
            className="absolute inset-0 opacity-70"
            style={{
              backgroundImage:
                "linear-gradient(rgba(255,255,255,0.28) 2px, transparent 2px), linear-gradient(90deg, rgba(255,255,255,0.28) 2px, transparent 2px)",
              backgroundSize: "var(--hero-grid) var(--hero-grid)",
            }}
          ></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">
            <h1 className="text-3xl font-bold tracking-tight text-white drop-shadow-lg md:text-5xl lg:text-6xl">
              Kebijakan Privasi
            </h1>
            <p className="mt-4 max-w-3xl text-base leading-relaxed text-blue-100/90 drop-shadow md:text-lg">
              Kebijakan ini menjelaskan bagaimana kami mengumpulkan,
              menggunakan, menjaga, dan membagikan informasi pengguna dalam
              layanan Tomi Indonesia.
            </p>
          </div>
        </section>

        <section className="section-shell bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-4xl space-y-8">
              {privacySections.map((section, index) => (
                <article
                  key={section.title}
                  className="border-b border-slate-200 pb-8 last:border-b-0 last:pb-0"
                >
                  <h2 className="mb-4 text-xl font-bold text-slate-900 sm:text-2xl">
                    {index + 1}. {section.title}
                  </h2>
                  <p className="section-copy">{section.content}</p>
                  {section.items && (
                    <ul className="mt-4 list-disc space-y-2 pl-5 text-sm leading-7 text-slate-600 sm:text-base">
                      {section.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                </article>
              ))}

            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPolicyPage;
